export const NO_SMOKE = { id: 'no-smoke', label: 'Non ha fumato' };
export const BEFORE_PREGNANCY = {
  id: 'before_pregnancy',
  label: 'Ha smesso prima della gravidanza',
};
export const EARLY_IN_PREGNANCY = {
  id: 'early_in_pregnancy',
  label: 'Ha smesso a inizio gravidanza',
};
export const CONTINOUS = { id: 'continous', label: 'Ha continuato a fumare in gravidanza' };
